<template>
  <div class="organization">
    <!-- <h1>acquirer</h1> -->
    <!-- <v-snackbar  v-model="snackbar" :timeout="6000" :color="snackbar_color" location="top" max-height="10cm" max-width="5cm"  multi-line>                  
        {{ snackbar_text }}          
    </v-snackbar> -->
    <v-row no-gutters>
      <v-col cols="auto" class="me-auto">
        <!-- <v-sheet class="ma-2 pa-2">Acquirer</v-sheet> -->
        <v-sheet class="pa-2">
          <v-breadcrumbs
            :items="[{ text: $t('devices'), disabled: true, href: '/' }]"
          ></v-breadcrumbs>
        </v-sheet>
      </v-col>
      <v-col cols="auto">
        <v-sheet class="pa-2">
          <v-btn
            class="button_size"
            color="blue"
            prepend-icon="mdi-plus"
            @click="compose"
            v-if="
              this.global_permissions.includes('ROLE_USER_ADMIN') ||
              this.global_permissions.includes('ROLE_USER_ASSIST')
            "
          >
            <template v-slot:prepend>
              <v-icon color="white"></v-icon>
            </template>
            {{ $t("add_device") }}
          </v-btn>
        </v-sheet>
      </v-col>
      <v-col cols="auto">
        <v-sheet class="pa-2 mr-10">
          <v-btn
            class="button_size"
            color="orange"
            prepend-icon="mdi-upload"
            @click="compose_excel"
            v-if="
              this.global_permissions.includes('ROLE_USER_ADMIN') ||
              this.global_permissions.includes('ROLE_USER_ASSIST')
            "
          >
            <template v-slot:prepend>
              <v-icon color="white"></v-icon>
            </template>
            <span class="text_color">{{ $t("batch_upload") }}</span>
          </v-btn>
        </v-sheet>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4" class="me-auto">
        <v-sheet class="pa-2">
          <v-text-field
            append-inner-icon="mdi-close-circle"
            append-icon="mdi-magnify"
            density="compact"
            :label="$t('search')"
            variant="solo"
            hide-details
            single-line
            dense
            v-model="query"
            @click:append-inner="resetData"
            @click:append="searchDevice"
          ></v-text-field>
        </v-sheet>
      </v-col>
      <!-- FOR USER  open a dialog to select all or an acquirer before exporting-->
      <v-col cols="auto mt-2">
        <v-sheet>
          <v-btn variant="text" @click="compose_select_acquirer" v-if="this.global_permissions.includes('ROLE_USER_ADMIN') || this.global_permissions.includes('ROLE_USER_ASSIST') ">
            <span class="mr-1">{{ $t("export") }}</span>
            <v-icon color="grey-darken-1">mdi mdi-download</v-icon>            
          </v-btn>
        </v-sheet>
      </v-col>
      <!-- FOR ADMIN -->
      <v-col cols="auto mt-2">
        <v-sheet>
          <v-btn variant="text" @click="compose_select_organization" v-if="this.global_permissions.includes('ROLE_STAFF_ADMIN') || this.global_permissions.includes('ROLE_STAFF_USER') ">
            <span class="mr-1">{{ $t("export") }}</span>
            <v-icon color="grey-darken-1">mdi mdi-download</v-icon>            
          </v-btn>
        </v-sheet>
      </v-col>
      <!-- <v-col cols="auto mt-2">
        <v-sheet">
          <v-btn variant="text">
            <span class="mr-1">{{ $t("export") }}</span>
            <v-icon color="grey-darken-1">mdi mdi-download</v-icon>
            <v-menu activator="parent">
              <v-list>
                <v-list-item>
                  <download-excel
                    class="btn btn-default"
                    :data="devices"
                    :fields="json_fields"
                    worksheet="My Worksheet"
                    name="Devices.xls"
                  >
                    <v-btn variant="text">xls</v-btn>
                  </download-excel>
                </v-list-item>
                <v-list-item>
                  <v-sheet>                    
                    <download-excel
                      class="btn btn-default"
                      :data="devices"
                      :fields="json_fields"
                      worksheet="My Worksheet"
                      type="csv"
                      name="Devices.xls"
                    >
                      <v-btn variant="text">csv</v-btn>
                    </download-excel>
                  </v-sheet>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-btn>
        </v-sheet>
      </v-col> -->      
      <v-col cols="auto" class="mt-2 mr-10">
        <v-sheet>
          <!-- <v-btn
            variant="text"
            color="red"
            @click="disableStatus"
            :disabled="!hasUsers"
            v-if="
              this.global_permissions.includes('ROLE_USER_ADMIN') ||
              this.global_permissions.includes('ROLE_USER_ASSIST')
            "
            >{{ $t("disable") }}</v-btn -->
          <v-btn
            variant="text"
            color="green"
            @click="enableStatus"
            :disabled="!hasUsers"
            v-if="
              this.global_permissions.includes('ROLE_USER_ADMIN') ||
              this.global_permissions.includes('ROLE_USER_ASSIST')
            "
            >{{ $t("enable") }}</v-btn
          >
          <v-btn
            variant="text"
            color="blue"
            @click="compose_download_device_status"
            v-if="
              this.global_permissions.includes('ROLE_USER_ADMIN') ||
              this.global_permissions.includes('ROLE_USER_ASSIST')
            "
            >{{ $t("update_status") }}</v-btn
          >
          <v-btn
            variant="text"
            color="orange"
            @click="compose_upload_serial"
            v-if="
              this.global_permissions.includes('ROLE_USER_ADMIN') ||
              this.global_permissions.includes('ROLE_USER_ASSIST')
            "
            >{{ $t("batch_config") }}</v-btn
          >
        </v-sheet>
      </v-col>
    </v-row>

    <!-- <v-row class="search_row">
      <v-col cols="4">                               
        <v-btn variant="text" color="red"  @click="disableStatus" :disabled="!hasUsers" >Disable</v-btn>
        <v-btn variant="text" color="green" @click="enableStatus" :disabled="!hasUsers" >Enable</v-btn>  
        <v-btn variant="text" color="blue" @click="compose_download_device_status" >Device Download Status</v-btn>                                            
      </v-col>            
    </v-row> -->

    <!-- Loading Spinner -->
    <v-progress-circular
      v-if="loading"
      indeterminate
      color="blue"
      size="25"
      class="loading-spinner"
    ></v-progress-circular>

    <v-card v-else class="mt-4 mr-10">
      <v-data-table
        v-model:expanded="expanded"
        :headers="headers"
        :items="devices"
        class="elevation-1 custom-table-style"
        :items-per-page="itemsPerPage"
        :items-length="totalItems"
        disable-pagination
        :hide-default-footer="true"
        :fixed-header="true"
        :loading="loading"
        v-model="selected"
        show-select
      >
        <!-- FOR GROUPING -->
        <!-- <template v-slot:column.data-table-group><div>Acquirer</div></template> -->

        <template v-slot:item.tid="{ item }">
          <p v-for="it in item.raw.merchantDetails" :key="it.id">
            {{ it.tid }}
          </p>
        </template>

        <!-- FOR EXPANSION -->
        <template v-slot:expanded-row="{ columns, item }">
          <!-- <tr>
            <td :colspan="columns.length">               
              More info about {{ item.value.deviceId }}
            </td>
          </tr> -->
          <tr>
            <td :colspan="columns.length">
              {{ $t("device_id") }} : {{ item.raw.id }}
            </td>
          </tr>
          <tr>
            <td :colspan="columns.length">
              {{ $t("device_operations") }} : {{ item.raw.allowedOperations }}
            </td>
          </tr>
          <tr>
            <td :colspan="columns.length">
              {{ $t("device_settlement_time") }} : {{ item.raw.stmTime }}
            </td>
          </tr>
          <tr>
            <td :colspan="columns.length">
              {{ $t("device_settlement_days") }} : {{ item.raw.settleDays }}
            </td>
          </tr>
          <tr>
            <td :colspan="columns.length">
              {{ $t("device_no_of_receipts") }} : {{ item.raw.receiptNumber }}
            </td>
          </tr>
          <tr v-if=" this.featureFlags.includes('DUAL_CURRENCY') || this.global_permissions.includes('ROLE_STAFF_ADMIN') || this.global_permissions.includes('ROLE_STAFF_USER')">           
            <td :colspan="columns.length">
              {{ $t("device_dual_currency") }} : {{ item.raw.doubleCurrency }}
            </td>
          </tr>
          <tr v-if=" this.featureFlags.includes('RECEIPT_BARCODE') || this.global_permissions.includes('ROLE_STAFF_ADMIN') || this.global_permissions.includes('ROLE_STAFF_USER')">           
            <td :colspan="columns.length">
              {{ $t("device_barcode") }} : {{ item.raw.receiptBarcode }}
            </td>
          </tr>
          <!-- <tr>
            <td :colspan="columns.length">
              {{ $t("device_downloadable") }} : {{ item.raw.downloadEnable }}
            </td>
          </tr> -->
          <tr>
            <td :colspan="columns.length">
              <!-- Merchant Pwd : {{ item.raw.merchantPwd }} -->
              {{ $t("device_merchant_pwd") }} :
              {{ maskedPassword(item.raw.merchantPwd) }}
            </td>
          </tr>
          <tr>
            <td :colspan="columns.length">
              <!-- Settings Pwd : {{ item.raw.settingsPwd }} -->
              {{ $t("device_settings_pwd") }} :
              {{ maskedPassword(item.raw.settingsPwd) }}
            </td>
          </tr>
          <tr>
            <td :colspan="columns.length">
              <!-- Date Created : {{ item.raw.createdAt }} -->
              {{ $t("device_created_at") }} :
              {{ formattedDate(item.raw.createdAt) }}
            </td>
          </tr>
          <tr>
            <td :colspan="columns.length">
              {{ $t("device_created_by") }} : {{ item.raw.createdBy }}
            </td>
          </tr>
          <tr>
            <td :colspan="columns.length">
              <!-- Date Updated : {{ item.raw.updatedAt }} -->
              {{ $t("device_updated_at") }} :
              {{ formattedDate(item.raw.updatedAt) }}
            </td>
          </tr>
          <tr>
            <td :colspan="columns.length">
              {{ $t("device_updated_by") }} : {{ item.raw.updatedBy }}
            </td>
          </tr>
        </template>

        <template v-slot:item.mid="{ item }">
          <p v-for="it in item.raw.merchantDetails" :key="it.id">
            {{ it.mid }}
          </p>
        </template>

        <template v-slot:item.cvm="{ item }">
          <p v-for="it in item.raw.merchantDetails" :key="it.id">
            {{ it.cvm }}
          </p>
        </template>

        <template v-slot:item.currencyName="{ item }">
          <p v-for="it in item.raw.merchantDetails" :key="it.id">
            {{ it.currency.currencyName }}
          </p>
        </template>

        <template v-slot:item.actions="{ item }">
          <!--<router-link :to="/update-device/+item.value.deviceId" v-if="this.global_permissions.includes('DEVICE_EDIT')"> <v-icon color="green" small class="mr-2" >mdi-pencil</v-icon></router-link>              
            <v-icon color="red" small @click="compose_delete(item.value.deviceId)" v-if="this.global_permissions.includes('DEVICE_DELETE')">mdi-delete</v-icon> -->

          <v-tooltip :text="$t('Update')" location="top">
            <template v-slot:activator="{ props }">
              <v-icon
                v-bind="props"
                small
                class="mr-2"
                color="green"
                @click="compose_update(item.raw.id)"
                v-if="
                  this.global_permissions.includes('ROLE_USER_ADMIN') ||
                  this.global_permissions.includes('ROLE_USER_ASSIST')
                "
                >mdi-pencil-circle</v-icon
              >
            </template>
          </v-tooltip>
          <v-tooltip :text="$t('Delete')" location="top">
            <template v-slot:activator="{ props }">
              <v-icon
                v-bind="props"
                small
                class="mr-2"
                color="red"
                @click="compose_delete(item.raw.id)"
                v-if="
                  this.global_permissions.includes('ROLE_USER_ADMIN') ||
                  this.global_permissions.includes('ROLE_STAFF_ADMIN')
                "
                >mdi-delete-circle</v-icon
              >
            </template>
          </v-tooltip>
        </template>

        <template v-slot:bottom>
          <div class="text-center pt-2">
            <v-pagination
              v-model="page"
              :length="pageCount"
              total-visible="7"
              @update:model-value="page"
            ></v-pagination>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- ADD DIALOG -->
    <v-dialog v-model="dialog" persistent width="900" max-height="800">
      <v-card>
        <v-card-title class="d-flex justify-space-between ma-3">
          <span class="text-h5">{{ $t("add_device") }}</span>
          <v-icon @click="dialog = false">mdi mdi-close-circle-outline</v-icon>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  :readonly="loading"
                  :rules="[required, validateSerial]"
                  maxlength="10"
                  clearable
                  placeholder="1850024134"
                  :label="$t('device_sn')"
                  @change="checkDevice(device_data.f_deviceSN)"
                  v-model="device_data.f_deviceSN"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <!-- <v-autocomplete
                          clearable
                          :items= "merchants"
                          item-title="merchantName"
                          item-value="merchantId"
                          label="Select Merchant*" 
                          v-model="device_data.f_merchantId"                         
                          :rules="[required]"
                        ></v-autocomplete>  -->

                <v-autocomplete
                  v-model="device_data.f_merchantId"
                  :items="merchants"
                  item-title="merchantName"
                  item-value="id"
                  :label="dynamicLabel"
                  v-model:search="search"
                  :placeholder="$t('Start typing')"
                  hide-no-data
                  hide-selected
                  no-filter
                  required
                >
                </v-autocomplete>
              </v-col>
              <v-divider></v-divider>
              <v-col cols="12">
                <p class="my-2">{{ $t("merchant_details") }}</p>
                <v-row
                  class="form-group"
                  v-for="(input, k) in device_data.f_merchantDetails"
                  :key="k"
                >
                  <v-col cols="3">
                    <v-text-field
                      :readonly="loading"
                      :rules="[required, validateTID]"
                      maxlength="8"
                      clearable
                      label="TID*"
                      required
                      v-model="input.tid"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      :readonly="loading"
                      :rules="[required, validateMID]"
                      clearable
                      label="MID*"
                      maxlength="15"
                      required
                      v-model="input.mid"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2">
                    <v-select
                      :items="currencies"
                      item-title="currencyName"
                      item-value="currencyCode"
                      :label="$t('select_currency')"
                      v-model="input.currencyCode"
                      :rules="[required]"
                    ></v-select>
                  </v-col>
                  <v-col cols="2">
                    <v-text-field
                      :readonly="loading"
                      :rules="[required, validateCVM]"
                      clearable
                      :label="$t('cvm_limit')"
                      required
                      v-model="input.cvm"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="1"
                    v-if="
                      k == device_data.f_merchantDetails.length - 1 &&
                      device_data.f_merchantDetails.length < 2
                    "
                  >
                    <v-btn
                      color="success"
                      icon="mdi-plus"
                      @click="add()"
                      style="min-width: 40px; width: 40px; height: 40px; margin-top: 8px; min-height: 40px"
                    ></v-btn>
                    <!--  v-show="k == device_data.f_merchantDetails.length - 1 && device_data.f_merchantDetails.length < 2" -->
                  </v-col>
                  <v-col cols="1" v-else>
                    <v-btn
                      color="red"
                      icon="mdi-minus"
                      @click="remove(k)"
                      style="min-width: 40px; width: 40px; height: 40px; margin-top: 8px; min-height: 40px"
                    ></v-btn>
                    <!-- v-show="k || (!k && device_data.f_merchantDetails.length > 1)"  -->
                  </v-col>
                </v-row>
              </v-col>
              <v-divider></v-divider>
              <v-col cols="12">
                <!-- <v-autocomplete
                                  :items="operations"
                                  item-title="operationName"
                                  item-value="operationId"
                                  label="Select Operation*"
                                  multiple
                                  v-model="device_data.f_operationList"
                                  :rules="[required]"
                                ></v-autocomplete> -->
                <p class="mb-2">{{ $t("select_operation") }}</p>
                <!-- <p>{{ device_data.f_operationList }}</p> -->
                <!-- <v-row>        
                        <v-checkbox
                          v-for="it in operations"
                          :key="it.operationId"
                          v-model="device_data.f_operationList"
                          :label="it.operationName"
                          :value="it.operationId"
                        ></v-checkbox> 
                        </v-row>  -->

                <v-row>
                  <v-col
                    cols="6"
                    class="py-0 my-0 pa-0"
                    lg="3"
                    md="4"
                    v-for="it in operations"
                    :key="it.operationId"
                  >
                    <v-checkbox
                      v-model="device_data.f_operationList"
                      :label="it.operationName"
                      :value="it.operationName"
                      dense
                      hide-details
                    >
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-col>
              <v-divider></v-divider>
              <v-col cols="12"
                ><p>{{ $t("settlement_config") }}</p></v-col
              >

              <!-- <v-col cols="12">                                 
                        <v-text-field :readonly="loading" :rules="[required]" clearable label="Settlement name*" v-model="device_data.f_settlement.name"></v-text-field>                                              
                    </v-col> -->
              <!-- <v-col cols="6">                                 
                        <v-select
                          :items= "['true', 'false']"                          
                          label="Select Status*"                          
                          :rules="[required]" 
                          v-model="device_data.f_settlement.status"                         
                        ></v-select>                                              
                    </v-col> -->
              <!-- <v-col cols="6">                                 
                      <v-text-field :readonly="loading" :rules="[required]" label="Settlement time*" v-model="device_data.f_settlement.time" type="time" suffix="PST" ></v-text-field>                                                
                    </v-col> -->
              <v-col cols="4">
                <v-text-field
                  :readonly="loading"
                  :label="$t('settlement_time')"
                  v-model="device_data.f_stmTime"
                  :rules="[required, validatestmTime]"
                  type="time"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <!-- <v-autocomplete
                            :items="days"
                            item-title="dayName"
                            item-value="dayId"
                            label="Select Settlement Days*"
                            multiple  
                            v-model="device_data.f_dayList" 
                            :rules="[required]"                       
                        ></v-autocomplete> -->
                <p class="mb-2">{{ $t("select_days") }}</p>
                <v-row>
                  <v-col
                    v-for="it in days"
                    :key="it.dayId"
                    class="py-0 my-0"
                    cols="6"
                    lg="3"
                    md="4"
                  >
                    <v-checkbox
                      v-model="device_data.f_dayList"
                      :label="it.dayName"
                      :value="it.dayName"
                      dense
                      hide-details
                    >
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-col>

              <v-divider></v-divider>

              <v-col cols="3">
                <v-text-field
                  :readonly="loading"
                  clearable
                  :label="$t('device_no_of_receipts')"
                  :rules="[required, validateReceipt]"
                  maxlength="1"
                  v-model="device_data.f_receiptNumber"
                ></v-text-field>
              </v-col>              
              <v-col cols="3">
                <v-select
                  :items="['true', 'false']"
                  :label="$t('device_downloadable')"
                  v-model="device_data.f_isDownloadEnable"
                ></v-select>
              </v-col>
              <v-col cols="3">
                <v-select
                  :items="['true', 'false']"
                  :label="$t('device_dual_currency')"
                  v-model="device_data.f_isDualCurrency"
                  v-if=" this.featureFlags.includes('DUAL_CURRENCY')"
                ></v-select>
              </v-col>
              <v-col cols="3">
                <v-select
                  :items="['true', 'false']"
                  :label="$t('device_barcode')"
                  v-model="device_data.f_barcode"
                  v-if=" this.featureFlags.includes('RECEIPT_BARCODE')"
                ></v-select>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  type="password"
                  :label="$t('device_merchant_pwd')"
                  v-model="device_data.f_merchantPwd"
                  :rules="[required, validatePassword]"
                  maxlength="6"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  type="password"
                  :label="$t('device_settings_pwd')"
                  v-model="device_data.f_settingPwd"
                  :rules="[required, validatePassword]"
                  maxlength="6"
                ></v-text-field>
              </v-col>

              <v-divider></v-divider>
            </v-row>
          </v-container>
          <small>* {{ $t("indicateRequires") }}</small>
        </v-card-text>
        <v-card-actions class="mb-3 ml-2">
          <v-spacer></v-spacer>
          <v-btn variant="text" @click="dialog = false">
            {{ $t("Close") }}
          </v-btn>
          <v-btn color="blue-darken-1" variant="text" @click="addDevice">
            {{ $t("Save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- END ADD DIALOG -->

    <!-- UPDATE  DIALOG -->
    <v-dialog v-model="dialog_update" persistent width="900" max-height="800">
      <v-card>
        <v-card-title class="d-flex justify-space-between ma-3">
          <span class="text-h5"> {{ $t("update_device") }}</span>
          <v-icon
            @click="dialog_update = false"
            style="width: 40px; height: 40px"
            >mdi mdi-close-circle-outline</v-icon
          >
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <!-- <v-text-field :readonly="loading" :rules="[required]" clearable placeholder="1850024134" label="Device SN*" @change="checkDevice" v-model="device_data.f_deviceSN" ></v-text-field> -->
                <v-text-field
                  :readonly="loading"
                  :rules="[required, validateSerial]"
                  maxlength="10"
                  clearable
                  placeholder="1850024134"
                  :label="$t('device_sn')"
                  @change="checkDevice(device_data.f_deviceSN)"
                  v-model="device_data.f_deviceSN"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <!-- <v-autocomplete
                          clearable
                          :items= "merchants"
                          item-title="merchantName"
                          item-value="merchantId"
                          label="Select Merchant*" 
                          v-model="device_data.f_merchantId"                         
                          :rules="[required]"
                        ></v-autocomplete> -->

                <!-- <v-autocomplete
                  v-model="device_data.f_merchantId"
                  :items="merchants"
                  item-title="merchantName"
                  item-value="id"
                  :label="$t('select_merchant')"
                  v-model:search="search"
                  :placeholder="$t('Start typing')"
                  hide-no-data
                  hide-selected
                  no-filter
                  :rules="[required]"
                >
                </v-autocomplete> -->

                <v-autocomplete
                  v-model="device_data.f_merchantId"
                  :items="merchants"
                  item-title="merchantName"
                  item-value="id"
                  :label="dynamicLabel"
                  v-model:search="search"
                  :placeholder="$t('Start typing')"
                  hide-no-data
                  hide-selected
                  no-filter
                  required
                  :loading="loading"
                  :disabled="loading"
                >
                </v-autocomplete>
              </v-col>
              <v-divider></v-divider>
              <v-col cols="12">
                <p>{{ $t("merchant_details") }}</p>
                <v-row
                  class="form-group"
                  v-for="(input, k) in device_data.f_merchantDetails"
                  :key="k"
                >
                  <v-col cols="3">
                    <v-text-field
                      :readonly="loading"
                      :rules="[required, validateTID]"
                      clearable
                      label="TID*"
                      required
                      v-model="input.tid"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      :readonly="loading"
                      :rules="[required, validateMID]"
                      clearable
                      label="MID*"
                      required
                      v-model="input.mid"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2">
                    <v-select
                      :items="currencies"
                      item-title="currencyName"
                      item-value="currencyCode"
                      :label="$t('select_currency')"
                      v-model="input.currencyCode"
                      :rules="[required]"
                    ></v-select>
                  </v-col>
                  <v-col cols="2">
                    <v-text-field
                      :readonly="loading"
                      :rules="[required, validateCVM]"
                      clearable
                      :label="$t('cvm_limit')"
                      required
                      v-model="input.cvm"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="1"
                    v-if="
                      k == device_data.f_merchantDetails.length - 1 &&
                      device_data.f_merchantDetails.length < 2
                    "
                  >
                    <v-btn
                      color="success"
                      icon="mdi-plus"
                      @click="add()"
                      style="min-width: 40px; width: 40px; height: 40px; margin-top: 8px; min-height: 40px"
                    ></v-btn>
                  </v-col>
                  <v-col cols="1" v-else>
                    <v-btn
                      color="red"
                      icon="mdi-minus"
                      @click="remove(k)"
                      style="min-width: 40px; width: 40px; height: 40px; margin-top: 8px; min-height: 40px"
                    ></v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <v-divider></v-divider>
              <v-col cols="12">
                <!-- <v-autocomplete
                                  :items="operations"
                                  item-title="operationName"
                                  item-value="operationId"
                                  label="Select Operation*"
                                  multiple
                                  v-model="device_data.f_operationList"
                                  :rules="[required]"
                                ></v-autocomplete> -->
                <p>{{ $t("select_operation") }}</p>
                <!-- <p>{{ device_data.f_operationList }}</p> -->
                <!-- <v-row>        
                        <v-checkbox
                          v-for="it in operations"
                          :key="it.operationId"
                          v-model="device_data.f_operationList"
                          :label="it.operationName"
                          :value="it.operationId"
                        ></v-checkbox> 
                        </v-row>  -->

                <v-row>
                  <v-col 
                  class="py-0 my-0"
                    cols="6"
                    lg="3"
                    md="4" 
                    v-for="it in operations" :key="it.operationId">
                    <v-checkbox
                      v-model="device_data.f_operationList"
                      :label="it.operationName"
                      :value="it.operationName"
                      dense
                      hide-details
                    >
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-col>
              <v-divider></v-divider>
              <v-col cols="12"
                ><p>{{ $t("settlement_config") }}</p></v-col
              >

              <!-- <v-col cols="12">                                 
                        <v-text-field :readonly="loading" :rules="[required]" clearable label="Settlement name*" v-model="device_data.f_settlement.name"></v-text-field>                                              
                    </v-col> -->
              <!-- <v-col cols="6">                                 
                        <v-select
                          :items= "['true', 'false']"                          
                          label="Select Status*"                          
                          :rules="[required]" 
                          v-model="device_data.f_settlement.status"                         
                        ></v-select>                                              
                    </v-col> -->
              <!-- <v-col cols="6">                                 
                      <v-text-field :readonly="loading" :rules="[required]" label="Settlement time*" v-model="device_data.f_settlement.time" type="time" suffix="PST" ></v-text-field>                                                
                    </v-col> -->
              <v-col cols="4">
                <v-text-field
                  :readonly="loading"
                  :label="$t('settlement_time')"
                  v-model="device_data.f_stmTime"
                  type="time"
                  :rules="[required, validatestmTime]"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <!-- <v-autocomplete
                            :items="days"
                            item-title="dayName"
                            item-value="dayId"
                            label="Select Settlement Days*"
                            multiple  
                            v-model="device_data.f_dayList" 
                            :rules="[required]"                       
                        ></v-autocomplete> -->
                <p class="mb-2">{{ $t("select_days") }}</p>
                <v-row>
                  <v-col
                    v-for="it in days"
                    :key="it.dayId"
                    class="py-0 my-0"
                    cols="6"
                    lg="3"
                    md="4"
                  >
                    <v-checkbox
                      v-model="device_data.f_dayList"
                      :label="it.dayName"
                      :value="it.dayName"
                      dense
                      hide-details
                    >
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-col>

              <v-divider></v-divider>

              <v-col cols="3">
                <v-text-field
                  :readonly="loading"
                  clearable
                  :label="$t('device_no_of_receipts')"
                  required
                  v-model="device_data.f_receiptNumber"
                  :rules="[required, validateReceipt]"
                  maxlength="1"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-select
                  :items="['true', 'false']"
                  :label="$t('device_downloadable')"
                  v-model="device_data.f_isDownloadEnable"
                ></v-select>
              </v-col>
              <v-col cols="3">
                <v-select
                  :items="['true', 'false']"
                  :label="$t('device_dual_currency')"
                  v-model="device_data.f_isDualCurrency"
                  v-if=" this.featureFlags.includes('DUAL_CURRENCY')"
                ></v-select>
              </v-col>              
              <v-col cols="3">
                <v-select
                  :items="['true', 'false']"
                  :label="$t('device_barcode')"
                  v-model="device_data.f_barcode"
                  v-if=" this.featureFlags.includes('RECEIPT_BARCODE')"
                ></v-select>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  type="password"
                  :label="$t('device_merchant_pwd')"
                  v-model="device_data.f_merchantPwd"
                  :rules="[required, validatePassword]"
                  maxlength="6"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  type="password"
                  :label="$t('device_settings_pwd')"
                  v-model="device_data.f_settingPwd"
                  :rules="[required, validatePassword]"
                  maxlength="6"
                ></v-text-field>
              </v-col>

              <v-divider></v-divider>
            </v-row>
          </v-container>
          <small>* {{ $t("indicateRequires") }}</small>
        </v-card-text>
        <v-card-actions class="mb-3 ml-2">
          <v-spacer></v-spacer>
          <v-btn variant="text" @click="dialog_update = false">
            {{ $t("Close") }}
          </v-btn>
          <v-btn color="blue-darken-1" variant="text" @click="updateDevice">
            {{ $t("Update") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- END UPDATE  DIALOG -->

    <!-- DELETE  DIALOG -->
    <!-- <v-dialog v-model="dialog_delete" persistent width="500">
      <v-card>
        <v-card-title>
          <span class="text-h5">do you want to delete?</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row> </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue-darken-1"
            variant="text"
            @click="dialog_delete = false"
          >
            Close
          </v-btn>
          <v-btn color="blue-darken-1" variant="text" @click="deleteDevice">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->

    <v-dialog v-model="dialog_delete" persistent width="400">
      <v-card>
        <template v-slot:title>
          <span class="font-weight-medium-black">{{ $t("deleteFile") }}</span>
        </template>

        <v-card-text class="bg-surface-light py-4">
          {{ $t("deleteText") }}
        </v-card-text>
        <v-card-actions class="mb-2 mr-2">
          <v-spacer></v-spacer>
          <v-btn color="red" variant="flat" @click="deleteDevice">{{
            $t("Delete")
          }}</v-btn>
          <v-btn variant="flat" @click="dialog_delete = false">{{
            $t("Close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- END UPDATE DIALOG -->

    <!-- UPLOAD  DIALOG -->
    <!-- <v-dialog v-model="dialog_excel" persistent width="500"  > 
         
            <v-card>
              <span style="text-align: center;">Batch Upload</span> 
              <span style="text-align: center;">
                    THIS ALLOWS ME TO DOWNLOAD .XLS FILE
                    <download-excel
                      class="btn btn-default"
                      :data="template_merchants"
                      :fields="template_json_fields"
                      worksheet="Merchants"
                      name="Merchants.xls"
                    >
                      <v-btn density="compact" color="black">Download Merchant Template</v-btn>
                    </download-excel>
                     THIS ALLOWS ME TO DOWNLOAD .XLXS FILE 
                    <vue-excel-xlsx
                      class="btn btn-default"
                      :data="data1"
                      :columns="template_columns"
                      :file-name="'Devices'"
                      :file-type="'xlsx'"
                      :sheet-name="'Devices'"                        
                    >
                      <v-btn density="compact" color="black">Download Template</v-btn>
                      Download Template
                    </vue-excel-xlsx>
              </span>
              <v-form v-model="form" @submit.prevent="onSubmit">
                <v-card-title>
                                     
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-file-input show-size clearable label="File input" v-model="file" @change="handleFileUpload( $event )"></v-file-input>
                      <v-file-input show-size clearable label="File input" @change="handleFileUpload( $event )"></v-file-input>                      
                    </v-row>
                  </v-container>
                  
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn variant="text" @click="dialog_excel = false">Close</v-btn>                  
                  <v-btn color="blue-darken-1" variant="text" @click="uploadDeviceFile">Upload</v-btn>                  
                </v-card-actions>
              </v-form>
              <small style="color: red;"> *File size should not be above 2MB</small>
              <small style="color: red;"> After downloading Save .xlxs file before storing data</small>
            </v-card>
    </v-dialog>   -->

    <v-dialog v-model="dialog_excel" persistent width="500">
      <v-card class="pa-3">
        <div class="container">
          <span style="text-align: center">{{ $t("batch_upload") }}</span>
        </div>
        <span style="text-align: center">
          <vue-excel-xlsx
            class="btn btn-default"
            :data="data1"
            :columns="template_columns"
            :file-name="'Devices'"
            :file-type="'xlsx'"
            :sheet-name="'Devices'"
          >
            <v-btn
              density="compact"
              color="white"
              height="48"
              min-width="164"
              >{{ $t("download_template") }}</v-btn
            >
            <!-- Download Template -->
          </vue-excel-xlsx>
        </span>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-card-title> </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <!-- <v-file-input show-size clearable label="File input" v-model="file" @change="handleFileUpload( $event )"></v-file-input> -->
                <v-file-input
                  show-size
                  clearable
                  :label="$t('file_input')"
                  @change="handleFileUpload($event)"
                ></v-file-input>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn variant="text" @click="dialog_excel = false">{{
              $t("Close")
            }}</v-btn>
            <v-btn
              color="blue-darken-1"
              variant="text"
              @click="uploadDeviceFile"
              >{{ $t("Upload") }}</v-btn
            >
          </v-card-actions>
        </v-form>
        <div class="container">
          <small style="color: red"> *{{ $t("file_size") }}</small>
          <small style="color: red"> {{ $t("uplaod_text") }}</small>
        </div>
      </v-card>
    </v-dialog>

    <!-- UPDATE SERIAL NUMBER -->
    <v-dialog v-model="dialog_upload_serial" persistent width="500">
      <v-card class="pa-3">
        <div class="container">
          <span style="text-align: center">{{ $t("batch_upload") }}</span>
        </div>
        <span style="text-align: center">
          <vue-excel-xlsx
            class="btn btn-default"
            :data="data1"
            :columns="template_columns_serial"
            :file-name="'DeviceSN'"
            :file-type="'xlsx'"
            :sheet-name="'Config'"
          >
            <v-btn
              density="compact"
              color="white"
              height="48"
              min-width="164"
              >{{ $t("download_template") }}</v-btn
            >
            <!-- Download Template -->
          </vue-excel-xlsx>
        </span>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-card-title> </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <!-- <v-file-input show-size clearable label="File input" v-model="file" @change="handleFileUpload( $event )"></v-file-input> -->
                <v-file-input
                  show-size
                  clearable
                  :label="$t('file_input')"
                  @change="handleFileUpload($event)"
                ></v-file-input>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn variant="text" @click="dialog_upload_serial = false">{{
              $t("Close")
            }}</v-btn>
            <v-btn
              color="blue-darken-1"
              variant="text"
              @click="uploadSerialFile"
              >{{ $t("Upload") }}</v-btn
            >
          </v-card-actions>
        </v-form>
        <div class="container">
          <small style="color: red"> *{{ $t("file_size") }}</small>
          <small style="color: red"> {{ $t("uplaod_text") }}</small>
        </div>
      </v-card>
    </v-dialog>

    <!-- UPDATE DOWNLOAD STATUS -->
    <v-dialog v-model="dialog_download_status" persistent width="700">
      <v-card>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5">{{ $t("update_status_text") }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <!-- <v-col cols="12">                                 
                      <v-select
                        :items="acquirer"
                        item-title="acquirerName"
                        item-value="acquirerId"                          
                        label="Select Acquirers"                          
                        :rules="[required]"
                        multiple
                        v-model="download_data.f_acquirerList"
                      ></v-select>                      
                    </v-col> -->
                  <v-col cols="12">
                    <v-autocomplete
                      :items="acquirer"
                      item-title="acquirerName"
                      item-value="acquirerId"
                      :label="$t('select_acquirers')"
                      :rules="[required]"
                      
                      v-model="download_data.f_acquirerList"
                    ></v-autocomplete>
                  </v-col>
                  <!-- <v-col cols="12">
                    <v-select
                      :items="['true', 'false']"
                      :label="$t('select_download_Status')"
                      v-model="download_data.f_status"
                    ></v-select>
                  </v-col> -->
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog_download_status = false">{{
                $t("Close")
              }}</v-btn>
              <v-btn
                color="success"
                type="submit"
                variant="text"
                @click="updateDownloadStatusAcquirer"
                >{{ $t("create_config") }}</v-btn
              >
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END UPDATE DOWNLOAD STATUS -->

    <!-- SELECT ACQUIRER FOR EXPORT -->
    <v-dialog v-model="dialog_select_acquirer" persistent width="700">
      <v-card>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5">Export Data</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">                                 
                      <!-- <v-select
                        :items="optionsWithSelectAll"
                        item-title="acquirerName"
                        item-value="acquirerId"                          
                        label="Select Acquirer"                          
                        :rules="[required]"                        
                        v-model="select_acquirer.f_acquirerId"
                      >                      
                      </v-select>    -->
                      <v-select
                        :items="acquirer"
                        item-title="acquirerName"
                        item-value="acquirerId"                          
                        label="Select Acquirer"                          
                        :rules="[required]"                        
                        v-model="select_acquirer.f_acquirerId"
                      >                      
                      </v-select>                      
                    </v-col>                
                  
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog_select_acquirer = false">{{
                $t("Close")
              }}</v-btn>
              
              <v-btn variant="text" @click="exportDeviceData(this.select_acquirer.f_acquirerId)">
                <span class="mr-1">{{ $t("export") }}</span>
                <v-icon color="grey-darken-1">mdi mdi-download</v-icon>                
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END SELECT ACQUIRER FOR EXPORT -->

    <!-- SELECT ORGANIZATION FOR EXPORT -->
    <v-dialog v-model="dialog_select_organization" persistent width="700">
      <v-card>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5">Export Data</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">                                 
                      <!-- <v-select
                        :items="orgWithSelectAll"
                        item-title="orgName"
                        item-value="orgId"                          
                        label="Select organization"                          
                        :rules="[required]"                        
                        v-model="select_acquirer.f_acquirerId"
                      >                      
                      </v-select> --> 
                      <v-select
                        :items="organization"
                        item-title="orgName"
                        item-value="orgId"                          
                        label="Select organization"                          
                        :rules="[required]"                        
                        v-model="select_acquirer.f_acquirerId"
                      >                      
                      </v-select>                     
                    </v-col>                 
                  
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog_select_organization = false">{{
                $t("Close")
              }}</v-btn>
              
              <v-btn variant="text" @click="exportDeviceDataForAdmin(this.select_acquirer.f_acquirerId)">
                <span class="mr-1">{{ $t("export") }}</span>
                <v-icon color="grey-darken-1">mdi mdi-download</v-icon>                
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END SELECT ORGANIZATION FOR EXPORT -->

  </div>
</template>

<script>
import axios from "axios";
//import JsonExcel from "vue-json-excel3";
export default {
  name: "Devices",

  data() {
    return {
      //name: '',
      emits: ["reload"],
      devices: [], //used
      exportDevices: [],
      organization: [],
      permissions: [],
      merchants: [],
      operations: [],
      days: [
        { dayId: "Monday", dayName: "Monday" },
        { dayId: "Tuesday", dayName: "Tuesday" },
        { dayId: "Wednesday", dayName: "Wednesday" },
        { dayId: "Thursday", dayName: "Thursday" },
        { dayId: "Friday", dayName: "Friday" },
        { dayId: "Saturday", dayName: "Saturday" },
        { dayId: "Sunday", dayName: "Sunday" },
      ],
      currencies: [],
      acquirer: [],

      dialog: false,
      dialog_update: false,
      dialog_delete: false,
      dialog_excel: false,
      dialog_download_status: false,
      dialog_upload_serial: false,
      dialog_select_acquirer: false,
      dialog_select_organization: false,

      device_data: {
        f_deviceSN: "",
        f_merchantId: "",
        f_merchantDetails: [{ tid: "", mid: "", cvm: "", currencyCode: "" }],
        f_operationList: [],
        f_dateCreated: "",
        f_dayList: [],
        f_stmTime: "",
        f_createByUserEmail: "",
        f_dateUpdated: "",
        f_updatedByUserEmail: "",
        f_receiptNumber: 2,
        f_isDualCurrency: false,
        f_isDownloadEnable: true,
        f_barcode: false,
        f_merchantPwd: "",
        f_settingPwd: "",

        //f_operationList: '',
        //f_dayList: '',
      },

      deviceId: "",
      existing_deviceSN: "",

      inputs: [
        //not in use
        { tid: "", mid: "", cvm: "" },
      ],

      search: "",
      selectedMerchantName: "",
      /* groupBy: [
        {            
          key: 'merchant.acquirer.acquirerName',
          order: 'asc',            
        },
      ], */

      expanded: [],

      headers: [
        /* { title: 'Acquirer', key: 'data-table-group' }, */
        {
          title: this.$t("device_sn"),
          align: "start",
          sortable: false,
          key: "deviceSN",
        },
        { title: "", key: "data-table-expand" },
        { title: this.$t("merchant_name"), key: "merchant.merchantName" },
        { title: this.$t("merchant_address"), key: "merchant.merchantAddress" },
        { title: "TID", key: "tid", sortable: true },
        { title: "MID", key: "mid", sortable: true },
        { title: this.$t("cvm_limit"), key: "cvm", sortable: true },
        { title: this.$t("currency"), key: "currencyName" },
        //{ title: 'Date Created', key: 'dateCreated' },
        //{ title: 'Date Updated', key: 'updatedBy' },
        { title: this.$t("Acquirer"), key: "merchant.acquirer.acquirerName" },
        {
          title: this.$t("organization"),
          key: "merchant.acquirer.organization.orgName",
        },
        //{ title: 'Actions', key: 'acquirerId', sortable: false },
        {
          title: this.$t("Actions"),
          key: "actions",
          sortable: false,
          width: "100px",
        },
      ],

      //FOR EXPORT
      json_fields: {
        "Device SN": "deviceSN",
        "Merchant Name": "merchant.merchantName",
        "Merchant Address": "merchant.merchantAddress",
        TID: {
          field: "merchantDetails",
          callback: (value) => {
            //console.log("ss length", value.length)
            let i = 0;
            let value1 = "";
            if (value != null && value.length == 1) {
              value1 = value[i].tid;
            }
            // if(value != null && value.length == 2){
            //   value2 = value[0].tid +"\n"+value[1].tid
            // }
            if (value != null && value.length > 1) {
              for (i = 0; i < value.length; i++) {
                //value1 = value[i].tid +" , "+value1
                value1 = value[i].tid + " \n " + value1;
              }
            }

            //return `Landline Phone - ${value[0].tid}`;
            return `${value1}`;
          },
        },
        MID: {
          field: "merchantDetails",
          callback: (value) => {
            //console.log("ss length", value.length)
            let u = 0;
            let value2 = "";
            if (value != null && value.length == 1) {
              value2 = value[u].mid;
            }
            // if(value != null && value.length == 2){
            //   value2 = value[0].mid +"\n"+value[1].mid
            // }
            if (value != null && value.length > 1) {
              for (u = 0; u < value.length; u++) {
                //value2 = value[u].mid +" , "+value2
                value2 = value[u].mid + " \n " + value2;
              }
            }

            //return `Landline Phone - ${value[0].tid}`;
            return `${value2}`;
          },
        },
        "CVM Limit": {
          field: "merchantDetails",
          callback: (value) => {
            //console.log("ss length", value.length)
            let u = 0;
            let value2 = "";
            if (value != null && value.length == 1) {
              value2 = value[u].cvm;
            }
            // if(value != null && value.length == 2){
            //   value2 = value[0].mid +"\n"+value[1].mid
            // }
            if (value != null && value.length > 1) {
              for (u = 0; u < value.length; u++) {
                //value2 = value[u].mid +" , "+value2
                value2 = value[u].cvm + " \n " + value2;
              }
            }

            //return `Landline Phone - ${value[0].tid}`;
            return `${value2}`;
          },
        },
        Currency: {
          field: "merchantDetails",
          callback: (value) => {
            //console.log("ss length", value.length)
            let w = 0;
            let value3 = "";
            if (value != null && value.length == 1) {
              value3 = value[w].currency.currencyName;
              console.log("device_currency", value3);
            }
            // if(value != null && value.length == 2){
            //   value2 = value[0].mid +"\n"+value[1].mid
            // }
            if (value != null && value.length > 1) {
              for (w = 0; w < value.length; w++) {
                //value2 = value[u].currency.currencyName +" , "+value2
                value3 = value[w].currency.currencyName + "\n" + value3;
                //console.log("device_currency1", value3)
              }
            }
            //console.log("device_currency2", value3)
            //return `Landline Phone - ${value[0].tid}`;
            return `${value3}`;
          },
        },
        Created: "createdAt",
        Updated: "updatedAt",
        "Acquirer name": "merchant.acquirer.acquirerName",
        Organization: "merchant.acquirer.organization.orgName",
      },

      //batch upload
      //THIS IS USED TO CREATE A TEMPLATE XLS FILE FOR DOWNLOAD
      template_devices: [""],
      /* template_json_fields: {
            "deviceSN": "",
            "Merchant": "",                          
            "stmTime": "",              
            "allowedOperations": "",
            "settleDays": "",
            "Created By": "",
      }, */

      //THIS IS USED TO CREATE A TEMPLATE XLXS FILE FOR DOWNLOAD
      //THE FIELD HAS TO BE ACCORDING TO THE NAMING IN THE ENTITY CLASS
      //NB: THE USER HAS TO DOWNLOADED ET RE SAVE  THE .XLXS FILE BEFORE IT WILL WORK
      template_columns: [
        {
          label: "deviceSN",
          field: "deviceSN",
        },
        {
          label: "Merchant ID",
          field: "merchant.id",
        },
        {
          label: "TID_1",
          field: "tid",
        },
        {
          label: "MID_1",
          field: "mid",
        },
        {
          label: "Currency Code",
          field: "currency",
        },
        {
          label: "CVM_1",
          field: "cvm",
        },
        {
          label: "Operations",
          field: "allowedOperations",
        },
        {
          label: "Stlm Days",
          field: "settleDays",
        },
        {
          label: "Stment Time",
          field: "stmTime",
        },
        {
          label: "Receipt Number",
          field: "receiptNumber",
        },
        {
          label: "Dual Currency",
          field: "doubleCurrency",
        },
        {
          label: "Created By",
          field: "createdBy",
        },
        {
          label: "Merchant Pwd",
          field: "merchantPwd",
        },
        {
          label: "Setting Pwd",
          field: "settingsPwd",
        },
      ],

      // Serial Number Template
      template_columns_serial: [
        {
          label: "deviceSN",
          field: "deviceSN",
        },
      ],
      // data1   HERE IS ACCORDING THE MERCHANT ENTITY
      data1: [
        {
          deviceSN: "",
          merchantAddress: "",
          mcc: {
            mccCode: "",
          },
          acquirer: {
            id: "",
          },
          createdBy: "",
        },
      ],

      //snackbar
      snackbar: false,
      snackbar_text: "",
      snackbar_color: "",

      //pagination
      page: 1,
      itemsPerPage: 5,
      totalItems: 0,
      totalPages: 0,
      query: "",
      loading: true,

      //selection
      selected: [],

      //download status
      download_data: {
        f_acquirerId: "",
        f_status: true,
      },

      //select acquirer
      select_acquirer: {
        f_acquirerId: "",        
      },  

    };
  },

  created() {},

  computed: {
    flatItems() {
      return this.devices.reduce(function (acc, v) {
        // console.log("per_object3", [...acc, ...v.merchantDetails]);
        return [...acc, ...v.merchantDetails];
      }, []);
    },

    pageCount() {
      // console.log("ssss", this.totalItems + " / " + this.itemsPerPage);
      let count = Math.ceil(this.totalItems / this.itemsPerPage);
      // console.log("ssss11 count : ", count);
      //return Math.ceil(this.totalItems / this.itemsPerPage)
      return count;
    },

    hasUsers() {
      return this.selected.length > 0;
    },

    dynamicLabel() {
      // Show 'Select Merchant' + Merchant Name only when a merchant is selected
      return this.selectedMerchantName
        ? `${this.$t("selected_merchant")} - ${this.selectedMerchantName}`
        : this.$t("select_merchant");
    },

    optionsWithSelectAll(){
      return [{acquirerId: "all", acquirerName:"All"}, ...this.acquirer]
    },

    orgWithSelectAll(){
      return [{orgId: "all", orgName:"All"}, ...this.organization]
    },

  },

  watch: {
    page(newPage) {
      this.page = newPage;
      this.fetchData();
      // console.log("new page", this.page);
    },

    onUpdatePageHandler(newPage) {
      this.page = newPage;
      //this.fetchData()
    },

    onItemsPerPageChange(newItemsPerPage) {
      this.itemsPerPage = newItemsPerPage;
      this.fetchData();
    },

    //auto-complete
    search(newSearch) {
      if (newSearch.length >= 2) {
        this.searchMerchant(newSearch);
      } else {
        this.merchants = [];
      }
    },

    // Watch the f_merchantId and update the selected merchant name
    "device_data.f_merchantId"(newMerchantId) {
      const selectedMerchant = this.merchants.find(
        (merchant) => merchant.id === newMerchantId
      );
      // Update the selectedMerchantName when a new merchant is selected
      this.selectedMerchantName = selectedMerchant
        ? selectedMerchant.merchantName
        : "";
    },
  },

  methods: {
    resetData() {
      this.query = "";
      this.fetchData();
    },

    resetInput() {
      this.device_data.f_deviceSN = "";
      this.device_data.f_merchantId = "";
      this.device_data.f_operationList = [];
      this.device_data.f_dateCreated = "";
      this.device_data.f_dayList = [];
      this.device_data.f_stmTime = "";
      this.device_data.f_createByUserEmail = "";
      this.device_data.f_dateUpdated = "";
      this.device_data.f_updatedByUserEmail = "";
      this.device_data.f_receiptNumber = 2;
      this.device_data.f_isDualCurrency = false;
      this.device_data.f_isDownloadEnable = true;
      this.device_data.f_barcode = false;
      this.device_data.f_merchantPwd = "";
      this.device_data.f_settingPwd = "";
      this.device_data.f_merchantDetails.forEach((detail) => {
        detail.tid = "";
        detail.mid = "";
        detail.cvm = "";
        detail.currencyCode = "";
      });
    },

    onSubmit() {
      if (!this.form) return;
    },

    device_check(v) {
      this.checkDevice(v);
      if (this.exist) return true;
      return "Device exist";
    },

    add() {
      //this.inputs.push({name: ''});
      this.device_data.f_merchantDetails.push({
        tid: "",
        mid: "",
        cvm: "",
        currencyId: "",
      });
    },

    remove(index) {
      // this.inputs.splice(index, 1);
      this.device_data.f_merchantDetails.splice(index, 1);
    },

    show_toast(status, color, text) {
      this.snackbar = status;
      this.snackbar_color = color;
      this.snackbar_text = text;
    },

    compose() {
      this.dialog = true;
      this.resetInput();
      this.checkTokenExpiry();
      this.requests_handler();
      //this.$root.vtoast.show({message: 'Ahoy there!', color: 'warning', icon: 'mdi-account'})
    },

    compose_update(id) {
      this.deviceId = id;
      this.dialog_update = true;
      this.checkTokenExpiry();
      this.requests_handler2();
    },

    compose_delete(id) {
      this.deviceId = id;
      this.dialog_delete = true;
    },

    compose_excel() {
      this.dialog_excel = true;
    },

    compose_upload_serial() {
      this.dialog_upload_serial = true;
    },

    enableStatus() {
      this.updateDownloadStatus(true);
    },

    disableStatus() {
      this.updateDownloadStatus(false);
    },

    compose_download_device_status() {
      this.dialog_download_status = true;
      this.checkTokenExpiry();
      this.requests_handler3();
    },

    compose_select_acquirer() {
      this.dialog_select_acquirer = true;
      this.checkTokenExpiry();
      this.requests_handler3();
    },

    compose_select_organization() {
      this.dialog_select_organization = true;
      this.checkTokenExpiry();
      this.requests_handler4();
    },

    requests_handler4() {
      axios
        .all([
          axios.get(window.baseurl + "organizations", {            
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
        ])
        .then(
          axios.spread((org_response) => {
            // console.log("data1", acq_response.data);

            if (org_response.status == 200) {
              if (
                org_response.data.records != null &&
                org_response.data.records.length > 0
              ) {
                let i = 0;
                this.organization = []; //remove all items from array
                for (i = 0; i < org_response.data.records.length; i++) {
                  this.organization.push({
                    orgId: org_response.data.records[i].id,
                    orgName: org_response.data.records[i].orgName,
                  });
                  
                }
              }
            }
          })
        );
    }, //end of requests_handler4 method

    customSearch(value, query) {
      //TESTING IT
      // console.log("HIII", value);
      // console.log("HAA", query);
      return (
        value != null &&
        query != null &&
        typeof value === "string" &&
        //value.toString().toLocaleUpperCase().indexOf(query) !== -1
        value.toString().toLocaleLowerCase().indexOf(query) !== -1
      );
    },

    requests_handler3() {
      axios
        .all([
          axios.get(window.baseurl + "acquirers/org/" + this.orgId, {
            params: { pagesize: 100 },
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
        ])
        .then(
          axios.spread((acq_response) => {
            // console.log("data1", acq_response.data);

            if (acq_response.status == 200) {
              if (
                acq_response.data.records != null &&
                acq_response.data.records.length > 0
              ) {
                let i = 0;
                this.acquirer = []; //remove all items from array
                for (i = 0; i < acq_response.data.records.length; i++) {
                  this.acquirer.push({
                    acquirerId: acq_response.data.records[i].id,
                    acquirerName: acq_response.data.records[i].acquirerName,
                  });
                  //console.log("acquirer", this.acquirer)
                }
              }
            }
          })
        );
    }, //end of requests_handler3 method

    requests_handler() {
      axios
        .all([
          /* axios.get(window.baseurl +"merchants/org/" +this.orgId , 
            {"headers": {'Authorization': 'Bearer ' + this.accessToken}}
          ), */
          axios.get(window.baseurl + "currencies", {
            params: { pagesize: 50 },
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
          axios.get(window.baseurl + "operations/org/" + this.orgId, {
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
          /* axios.get(window.baseurl+""+"sDays/list" , 
            {"headers": {'Authorization': 'Bearer ' + this.accessToken}}
          ) */
        ])
        .then(
          axios.spread((cur_response, ope_response) => {
            //console.log("data1", mer_response.data)
            // console.log("data2", cur_response.data);
            // console.log("data3", ope_response.data);
            //console.log("data4", days_response.data)
            //console.log("data10", this.user_org)

            /* if(mer_response.status == 200){  
                if(mer_response.data.records != null && mer_response.data.records.length > 0){
                    let i = 0;
                    this.merchants = [];   //remove all items from array
                    for(i=0; i<mer_response.data.records.length; i++){   
                       let merchant_name =   mer_response.data.records[i].merchantName + " - "+ mer_response.data.records[i].merchantAddress;                                               
                        //this.merchants.push({ merchantId: mer_response.data[i].merchantId, merchantName: mer_response.data[i].merchantName }); 
                        this.merchants.push({ merchantId: mer_response.data.records[i].id, merchantName: merchant_name });                          
                        //console.log("merchants", this.merchants)                         
                    }                      
                }                  
            }  */

            if (cur_response.status == 200) {
              if (
                cur_response.data.records != null &&
                cur_response.data.records.length > 0
              ) {
                let i = 0;
                this.currencies = []; //remove all items from array
                for (i = 0; i < cur_response.data.records.length; i++) {
                  this.currencies.push({
                    currencyCode: cur_response.data.records[i].currencyCode,
                    currencyName: cur_response.data.records[i].currencyName,
                  });
                  //console.log("Currencies", this.currencies)
                }
              }
            }

            if (ope_response.status == 200) {
              if (
                ope_response.data.records != null &&
                ope_response.data.records.length > 0
              ) {
                let i = 0;
                this.operations = []; //remove all items from array
                for (i = 0; i < ope_response.data.records.length; i++) {
                  this.operations.push({
                    operationId: ope_response.data.records[i].id,
                    operationName: ope_response.data.records[i].operationName,
                  });
                  // console.log("operations", this.operations);
                }
              }
            }

            /* if(days_response.status == 200){  
                if(days_response.data != null && days_response.data.length > 0){
                    let i = 0;
                    this.days = [];   //remove all items from array
                    for(i=0; i<days_response.data.length; i++){                                                    
                        this.days.push({ dayId: days_response.data[i].dayId, dayName: days_response.data[i].dayName });                          
                        console.log("days", this.days)
                       
                    }                      
                }                  
            }   */
          })
        );
    }, //end of requests_handler method

    requests_handler2() {
      // console.log("id", this.deviceId);
      this.loading = true;
      axios
        .all([
          axios.get(window.baseurl + "" + "devices/" + this.deviceId, {
            headers: { Authorization: "Bearer " + this.accessToken },
          }),

          /* axios.get(window.baseurl +"merchants/org/" +this.orgId , 
            {"headers": {'Authorization': 'Bearer ' + this.accessToken}}
          ), */
          axios.get(window.baseurl + "currencies", {
            params: { pagesize: 50 },
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
          axios.get(window.baseurl + "operations/org/" + this.orgId, {
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
        ])
        .then(
          axios.spread((dev_response, cur_response, ope_response) => {
            // console.log("data1", dev_response.data);

            //get data for selected id and display data in for dialog
            if (dev_response.status == 200) {
              //this.acquirer_response = acquirer_response.data,
              // console.log("devices Data", this.dev_response);
              this.device_data.f_deviceSN = dev_response.data.deviceSN;
              this.device_data.f_merchantId = dev_response.data.merchant.id;
              //this.device_data.f_merchantId = dev_response.data.merchant.merchantName
              //this is used for my new implementation of v-autocomplete
              this.merchants = [];
              this.selectedMerchantName =
                dev_response.data.merchant.merchantName;
              // console.log("Selected Merchant Name",this.selectedMerchantName);
              // let merchant_name = dev_response.data.merchant.merchantName;
              this.merchants.push({
                id: dev_response.data.merchant.id,
                merchantName: dev_response.data.merchant.merchantName,
              });
              // let merchant_name =
              //   dev_response.data.merchant.merchantName +
              //   " - " +
              //   dev_response.data.merchant.merchantAddress;
              // this.merchants.push({
              //   id: dev_response.data.merchant.id,
              //   merchantName: merchant_name,
              // });

              this.existing_deviceSN = dev_response.data.deviceSN; //to record SN

              let i = 0;
              this.device_data.f_merchantDetails = []; //remove all items from array
              for (i = 0; i < dev_response.data.merchantDetails.length; i++) {
                this.device_data.f_merchantDetails.push({
                  tid: dev_response.data.merchantDetails[i].tid,
                  mid: dev_response.data.merchantDetails[i].mid,
                  cvm: dev_response.data.merchantDetails[i].cvm,
                  currencyCode:
                    dev_response.data.merchantDetails[i].currency.currencyCode,
                });
                // console.log(
                //   "Merchantdetails",
                //   this.device_data.f_merchantDetails
                // );
              }

              this.device_data.f_operationList = []; //remove all items from array
              if (dev_response.data.allowedOperations != null) {
                let str = dev_response.data.allowedOperations;
                let str_array = str.split(",");
                for (let i = 0; i < str_array.length; i++) {
                  // Trim the excess whitespace.
                  str_array[i] = str_array[i]
                    .replace(/^\s*/, "")
                    .replace(/\s*$/, "");
                  // Add additional code here, such as:
                  //alert(str_array[i]);
                  // console.log("operation", str_array[i]);
                  this.device_data.f_operationList.push(str_array[i]);
                }
              }

              this.device_data.f_stmTime = dev_response.data.stmTime;
              this.device_data.f_receiptNumber =
                dev_response.data.receiptNumber;
              this.device_data.f_isDualCurrency =
                dev_response.data.doubleCurrency;
              this.device_data.f_isDownloadEnable =
                dev_response.data.downloadEnable;
              this.device_data.f_merchantPwd = dev_response.data.merchantPwd;
              this.device_data.f_settingPwd = dev_response.data.settingsPwd;
              this.device_data.f_barcode = dev_response.data.receiptBarcode;

              this.device_data.f_dayList = []; //remove all items from array
              if (dev_response.data.settleDays != null) {
                let str = dev_response.data.settleDays;
                let str_array = str.split(",");
                for (let i = 0; i < str_array.length; i++) {
                  // Trim the excess whitespace.
                  str_array[i] = str_array[i]
                    .replace(/^\s*/, "")
                    .replace(/\s*$/, "");
                  // Add additional code here, such as:
                  //alert(str_array[i]);
                  // console.log("operation", str_array[i]);
                  this.device_data.f_dayList.push(str_array[i]);
                }
              }
            }

            /* if(mer_response.status == 200){  
                if(mer_response.data.records != null && mer_response.data.records.length > 0){
                    let i = 0;
                    this.merchants = [];   //remove all items from array
                    for(i=0; i<mer_response.data.records.length; i++){   
                       let merchant_name =   mer_response.data.records[i].merchantName + " - "+ mer_response.data.records[i].merchantAddress;                                               
                        //this.merchants.push({ merchantId: mer_response.data[i].merchantId, merchantName: mer_response.data[i].merchantName }); 
                        this.merchants.push({ merchantId: mer_response.data.records[i].id, merchantName: merchant_name });                          
                        //console.log("merchants", this.merchants)                         
                    }                      
                }                  
            }  */

            if (cur_response.status == 200) {
              if (
                cur_response.data.records != null &&
                cur_response.data.records.length > 0
              ) {
                let i = 0;
                this.currencies = []; //remove all items from array
                for (i = 0; i < cur_response.data.records.length; i++) {
                  this.currencies.push({
                    currencyCode: cur_response.data.records[i].currencyCode,
                    currencyName: cur_response.data.records[i].currencyName,
                  });
                  //console.log("Currencies", this.currencies)
                }
              }
            }

            if (ope_response.status == 200) {
              if (
                ope_response.data.records != null &&
                ope_response.data.records.length > 0
              ) {
                let i = 0;
                this.operations = []; //remove all items from array
                for (i = 0; i < ope_response.data.records.length; i++) {
                  this.operations.push({
                    operationId: ope_response.data.records[i].id,
                    operationName: ope_response.data.records[i].operationName,
                  });
                  // console.log("operations", this.operations);
                }
              }
            }
          })
        );
      this.loading = false;
    }, //end of requests_handler 2 method

    //check device
    async checkDevice(sn) {
      this.checkTokenExpiry();
      this.exist = false;

      // console.log("DEVICE SN", sn);

      try {
        //let result_SN = await axios.get(window.baseurl+""+"device/get/"+""+this.device_data.f_deviceSN+""+"/serial_number")
        let result_SN = await axios.get(window.baseurl + "devices/sn/" + sn, {
          headers: { Authorization: "Bearer " + this.accessToken },
        });
        // console.log("RESPONSE", result_SN);
        if (result_SN.status == 200) {
          //this.show_toast(true, "warning", "Device exist");
          //this.$root.vtoast.showError({message: 'Device exist'})
          this.$root.vtoast.showError({ message: sn + this.$t("device_exit") });
          // console.log("EXIST", "device exist");
          this.exist = true;
          //console.log("EXIST value 1", this.exist)
        }
      } catch (err) {
        // console.log("EXIST", "device does not exist");
        // console.log(err.response.data);
        this.exist = false;
      }
    },

    async addDevice() {
      this.checkTokenExpiry();
      //console.log("existing device", this.existing_deviceSN);
      //console.log("device SN  in form", this.device_data.f_deviceSN);

      //check if device exist in database before submitting data

      /* try {
            let result_SN = await axios.get(window.baseurl+""+"device/get/"+""+this.device_data.f_deviceSN+""+"/serial_number" , {"headers": {'Authorization': 'Bearer ' + this.$cookies.get("accessToken")}} )
             console.log("RESPONSE", result_SN)
            if (result_SN.status == 200) {
              //alert("device exist");
              this.show_toast(true, "warning", "Device exist");
              console.log("EXIST", "device exist")
              this.exist = true;
              console.log("EXIST value 1", this.exist)
            }   
          }
          catch (err) {
            console.log("EXIST", "device does exist")
            console.log(err.response.data);
            if(err.response.data.message == "No value present" && err.response.data.status == 500){
              this.exist = false;
              console.log("EXIST value 2", this.exist)
            }
          }  */

      //this.checkDevice();
      if (this.exist) {
        // console.log("EXIST112", this.exist);
        this.$root.vtoast.showError({ message: this.$t("device_exit") });
        // this.$root.vtoast.showError({ message: "Device exist" });
      } else {
        //console.log("EXIST113", this.exist)
        //console.log("form data2", this.device_data);
        
        // Filter out elements from arrayA that are not present in arrayB's name property   //TO SOLVE ISSUE ISSUE WHERE OLD element WHICH IS NOT PART OF OPERATIONS LIST REMAINS
        //this.device_data.f_operationList = this.device_data.f_operationList.filter(item => this.operations.includes(item));
        this.device_data.f_operationList = this.device_data.f_operationList.filter(itemA =>
          this.operations.some(itemB => itemB.operationName === itemA)
        );
        this.device_data.f_dayList = this.device_data.f_dayList.filter(itemA =>
          this.days.some(itemB => itemB.dayName === itemA)
        );
        try {
          let result = await axios.post(
            window.baseurl + "devices",
            {
              deviceSN: this.device_data.f_deviceSN,
              merchant_id: this.device_data.f_merchantId,
              merchantDetails: this.device_data.f_merchantDetails,
              //allowedOperations:this.device_data.f_operationList,
              allowedOperations: this.device_data.f_operationList.join(),

              stmTime: this.device_data.f_stmTime,
              //settleDays:this.device_data.f_dayList,
              settleDays: this.device_data.f_dayList.join(),
              receiptNumber: this.device_data.f_receiptNumber,
              doubleCurrency: this.device_data.f_isDualCurrency,
              downloadEnable: this.device_data.f_isDownloadEnable,
              createdBy: this.userEmail,
              updatedBy: this.userEmail,
              merchantPwd: this.device_data.f_merchantPwd,
              settingsPwd: this.device_data.f_settingPwd,
              receiptBarcode: this.device_data.f_barcode,
            },
            { headers: { Authorization: "Bearer " + this.accessToken } }
          );
          if (result.status == 201) {
            // this.$root.vtoast.show({ message: result.data.message });
            this.$root.vtoast.show({ message: this.$t("device_created") });
            window.setInterval(() => {
              this.dialog = false;
              this.$emit("reload");
            }, this.waiting_time);
          }
        } catch (error) {
          //console.log(error.response.data);

          if (error.response.status == 417) {
            this.$root.vtoast.showError({
              message: error.response.data.message,
            });
          } else if (error.response.status == 500) {
            this.$root.vtoast.showError({
              message: error.response.data.detail,
            });
          } else {
            this.$root.vtoast.showError({
              message: error.response.data.message,
            });
          }
        }
      }
    },

    async updateDevice() {
      this.checkTokenExpiry();
      // console.log("device ID", this.deviceId);
      // console.log("existing device", this.existing_deviceSN);
      // console.log("device SN  in form", this.device_data.f_deviceSN);

      //check if device exist in database before submitting data
      /* if(this.existing_deviceSN != this.device_data.f_deviceSN){
          console.log(" NOT EQUAL", this.device_data.f_deviceSN)
          try {
            let result_SN = await axios.get(window.baseurl+""+"device/get/"+""+this.device_data.f_deviceSN+""+"/serial_number" , {"headers": {'Authorization': 'Bearer ' + this.$cookies.get("accessToken")}})
             console.log("RESPONSE", result_SN)
            if (result_SN.status == 200) {
              //alert("device exist");
              this.show_toast(true, "warning", "Device exist");                
              console.log("EXIST", "device exist")
              this.exist = true;
              console.log("EXIST value 1", this.exist)
            }   
          }
          catch (err) {
            console.log("EXIST", "device does exist")
            console.log(err.response.data);
            if(err.response.data.message == "No value present" && err.response.data.status == 500){
              this.exist = false;
              console.log("EXIST value 2", this.exist)
            }
          } 
        }
        else{ 
            console.log("EQUAL", "true")          
            this.exist = false;
        } */

      //if exist do not submit else submit
      //this.checkDevice();
      if (this.exist) {
        // console.log("EXIST112", this.exist);
        //this.show_toast(true, "warning", "Device exist");
        this.$root.vtoast.showError({ message: this.$t("device_exit") });
      } else {
        // console.log("EXIST113", this.exist);
        // console.log("form data2", this.device_data);
        // console.log("form data111", this.userEmail);
        // console.log("Download Status", this.device_data.f_isDownloadEnable);

        
        // Filter out elements from arrayA that are not present in arrayB's name property   //TO SOLVE ISSUE ISSUE WHERE OLD element WHICH IS NOT PART OF OPERATIONS LIST REMAINS
        //this.device_data.f_operationList = this.device_data.f_operationList.filter(item => this.operations.includes(item));
        this.device_data.f_operationList = this.device_data.f_operationList.filter(itemA =>
          this.operations.some(itemB => itemB.operationName === itemA)
        );
        this.device_data.f_dayList = this.device_data.f_dayList.filter(itemA =>
          this.days.some(itemB => itemB.dayName === itemA)
        );
        try {
          let result = await axios.put(
            window.baseurl + "" + "devices/" + this.deviceId,
            {
              deviceSN: this.device_data.f_deviceSN,
              merchant_id: this.device_data.f_merchantId,
              merchantDetails: this.device_data.f_merchantDetails,
              //allowedOperations:this.device_data.f_operationList,
              allowedOperations: this.device_data.f_operationList.join(),

              stmTime: this.device_data.f_stmTime,
              //settleDays:this.device_data.f_dayList,
              settleDays: this.device_data.f_dayList.join(),
              receiptNumber: this.device_data.f_receiptNumber,
              doubleCurrency: this.device_data.f_isDualCurrency,
              downloadEnable: this.device_data.f_isDownloadEnable,
              updatedBy: this.userEmail,
              merchantPwd: this.device_data.f_merchantPwd,
              settingsPwd: this.device_data.f_settingPwd,
              receiptBarcode: this.device_data.f_barcode,
            },
            { headers: { Authorization: "Bearer " + this.accessToken } }
          );
          if (result.status == 200) {
            //alert("successfull");
            //this.show_toast(true, "success", "Successful");
            // this.$root.vtoast.show({ message: result.data.message });
            this.$root.vtoast.show({ message: this.$t("device_updated") });
            window.setInterval(() => {
              this.dialog_update = false;
              this.$emit("reload");
            }, this.waiting_time);
          }
        } catch (error) {
          // console.log(error.response.data);
          //this.show_toast(true, "warning", err.response.message);
          if (error.response.status == 417) {
            this.$root.vtoast.showError({
              message: error.response.data.message,
            });
          } else if (error.response.status == 500) {
            this.$root.vtoast.showError({
              message: error.response.data.detail,
            });
          } else {
            this.$root.vtoast.showError({
              message: error.response.data.message,
            });
          }
        }
      }
    },

    async deleteDevice() {
      this.checkTokenExpiry();
      this.dialog_delete = false;
      try {
        let result = await axios.delete(
          window.baseurl + "" + "devices/" + this.deviceId,
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );
        if (result.status == 204) {
          // this.$root.vtoast.show({ message: result.data.message });
          this.$root.vtoast.show({ message: this.$t("device_deleted") });
          window.setInterval(() => {
            this.$emit("reload");
          }, this.waiting_time);
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.response.data.message });
      }
    },

    //UPLOAD FILE

    handleFileUpload(event) {
      this.file = event.target.files[0];
    },

    async uploadDeviceFile() {
      this.checkTokenExpiry();
      // console.log("file" + this.file);

      if (this.file) {
        this.loading = true;
        let formData = new FormData();
        formData.append("file", this.file);
        try {
          let result = await axios.post(
            window.baseurl + "devices/upload",
            formData,
            {
              headers: {
                Authorization: "Bearer " + this.accessToken,
                "content-type": "multipart/form-data",
              },
            }
          );
          //console.warn("result", result);
          if (result.status == 201) {
            //alert("successfull");
            //this.show_toast(true, "success", "Successful");
            // this.$root.vtoast.show({ message: result.data.message });
            this.$root.vtoast.show({ message: this.$t("device_created") });
            window.setInterval(() => {
              this.dialog_excel = false;
              this.$emit("reload");
            }, this.waiting_time);
          }
          this.loading = false;
        } catch (error) {
          //this.show_toast(true, "warning", error.message);
          this.loading = false;
          if (error.response.status == 417) {
            this.$root.vtoast.showError({
              message: error.response.data.message,
            });
          } else if (error.response.status == 500) {
            this.$root.vtoast.showError({
              message: error.response.data.detail,
            });
          } else {
            this.$root.vtoast.showError({
              message: error.response.data.message,
            });
          }
        }
      } else {
        // console.log("there are no files.");
        this.$root.vtoast.showError({ message: this.$t("no_file") });
      }
    },

    // Upload Serial Number
    async uploadSerialFile() {
      this.checkTokenExpiry();
      // console.log("file" + this.file);

      if (this.file) {
        this.loading = true;
        let formData = new FormData();
        formData.append("file", this.file);
        try {
          let result = await axios.post(
            window.baseurl + "devices/upload/config",
            formData,
            {
              headers: {
                Authorization: "Bearer " + this.accessToken,
                "content-type": "multipart/form-data",
              },
            }
          );
          //console.warn("result", result);
          if (result.status == 201) {
            //alert("successfull");
            //this.show_toast(true, "success", "Successful");
            // this.$root.vtoast.show({ message: result.data.message });
            this.$root.vtoast.show({ message: this.$t("d_status_updated") });
            window.setInterval(() => {
              this.dialog_excel = false;
              this.$emit("reload");
            }, this.waiting_time);
          }
          this.loading = false;
        } catch (error) {
          //this.show_toast(true, "warning", error.message);
          this.loading = false;
          if (error.response.status == 417) {
            this.$root.vtoast.showError({
              message: error.response.data.message,
            });
          } else if (error.response.status == 500) {
            this.$root.vtoast.showError({
              message: error.response.data.detail,
            });
          } else {
            this.$root.vtoast.showError({
              message: error.response.data.message,
            });
          }
        }
      } else {
        // console.log("there are no files.");
        this.$root.vtoast.showError({ message: this.$t("no_file") });
      }
    },

    //Update device download status using device ID
    async updateDownloadStatus(status) {
      this.checkTokenExpiry();
      this.loading = true;
      try {
        let result = await axios.put(
          window.baseurl2 + "devices/sn/status",
          this.selected,
          {
            params: { status: status },
            headers: { Authorization: "Bearer " + this.accessToken },
          }
        );

        // console.log("update form user result", result);
        if (result.status == 200) {          
          // this.$root.vtoast.show({ message: result.data.message });
          this.$root.vtoast.show({ message: this.$t("d_status_updated") });
          window.setInterval(() => {
            //this.dialog_update = false
            this.$emit("reload");
          }, this.waiting_time);
        }
        this.loading = false;
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        // console.log("Device Error", error);
        this.loading = false;
        if (error.response.status == 417) {
          this.$root.vtoast.showError({ message: error.response.data.message });
        } else if (error.response.status == 500) {
          this.$root.vtoast.showError({ message: error.response.data.detail });
        } else {
          this.$root.vtoast.showError({ message: error.message });
        }
      }
    },

    //Update device download status using acquirer ID
    async updateDownloadStatusAcquirer() {
      this.checkTokenExpiry();
      const newAcquirerList = [];
      //newAcquirerList.push(this.download_data.f_acquirerList[0]);
      newAcquirerList.push(this.download_data.f_acquirerList);
      // console.log("New Acquirer List: ", newAcquirerList);
      // console.log("Acquirer ID: ", this.download_data.f_acquirerList);
      // console.log("Acquirer ID[0]: ", this.download_data.f_acquirerList[0]);
      this.loading = true;
      try {
        let result = await axios.put(
          window.baseurl2 + "devices/acq/status",
          newAcquirerList,
          {
            params: { status: this.download_data.f_status },
            headers: { Authorization: "Bearer " + this.accessToken },
          }
        );

        // console.log("update form user result", result);
        if (result.status == 200) {
          // this.$root.vtoast.show({ message: result.data.message });
          this.$root.vtoast.show({ message: this.$t("d_status_updated") });
          window.setInterval(() => {
            //this.dialog_update = false
            this.$emit("reload");
          }, this.waiting_time);
        }
        this.loading = false;
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        // console.log("Device Error", error);
        this.loading = false;
        if (error.response.status == 417) {
          this.$root.vtoast.showError({ message: error.response.data.message });
        } else if (error.response.status == 500) {
          this.$root.vtoast.showError({ message: error.response.data.detail });
        } else {
          this.$root.vtoast.showError({ message: error.response.message });
        }
      }
    },

    async fetchData() {
      let result;
      let page2 = this.page - 1;
      this.loading = true;
      try {
        if (
          this.global_permissions.includes("ROLE_STAFF_ADMIN") ||
          this.global_permissions.includes("ROLE_STAFF_USER")
        ) {
          result = await axios.get(window.baseurl + "devices", {
            params: { page: page2 },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          // console.log("device_object", result);
          this.devices = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        } else if (
          this.global_permissions.includes("ROLE_USER_ADMIN") ||
          this.global_permissions.includes("ROLE_USER_ASSIST")
        ) {
          /* result = await axios.get(window.baseurl + "merchants/org/" + this.orgId, {
              "headers": {'Authorization': 'Bearer ' + this.accessToken} 
            }); */
          result = await axios.get(
            window.baseurl + "devices/org/" + this.orgId,
            {
              params: { page: page2 },
              headers: { Authorization: "Bearer " + this.accessToken },
            }
          );

          // console.log("device_object", result);
          this.devices = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.response.data.message });
        this.loading = false;
      }
    },

    async searchDevice() {
      let result;
      let page2 = this.page - 1;
      this.loading = true;
      this.checkTokenExpiry();
      try {
        if (
          this.global_permissions.includes("ROLE_STAFF_ADMIN") ||
          this.global_permissions.includes("ROLE_STAFF_USER")
        ) {
          result = await axios.get(window.baseurl + "devices/search", {
            params: { page: page2, search: this.query },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          // console.log("device_object_search", result);
          this.devices = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        } else if (
          this.global_permissions.includes("ROLE_USER_ADMIN") ||
          this.global_permissions.includes("ROLE_USER_ASSIST")
        ) {
          result = await axios.get(
            window.baseurl + "devices/org/search/" + this.orgId,
            {
              params: { page: page2, search: this.query },
              headers: { Authorization: "Bearer " + this.accessToken },
            }
          );

          // console.log("device_object", result);
          this.devices = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.response.data.message });
        this.loading = false;
      }
    },

    async searchMerchant(search) {
      // console.log("in searchMerchant", search);
      this.checkTokenExpiry();
      let result;

      this.merchants = [];
      //this.loading = true;
      let page2 = this.page - 1;
      if (search.length < 2) {
        this.merchants = [];
        return;
      }
      try {
        if (
          this.global_permissions.includes("ROLE_STAFF_ADMIN") ||
          this.global_permissions.includes("ROLE_STAFF_USER")
        ) {
          result = await axios.get(window.baseurl + "merchants/search", {
            params: { page: page2, search: search },
            headers: { Authorization: "Bearer " + this.accessToken },
          });
          console.log("activity_search_object", result);
          this.merchants = result.data.records;
        } else if (
          this.global_permissions.includes("ROLE_USER_ADMIN") ||
          this.global_permissions.includes("ROLE_USER_ASSIST")
        ) {
          result = await axios.get(
            window.baseurl + "merchants/org/search/" + this.orgId,
            {
              params: { page: page2, search: search },
              headers: { Authorization: "Bearer " + this.accessToken },
            }
          );
          // console.log("activity_search_object", result);
          this.merchants = result.data.records;
        }
      } catch (error) {
        this.show_toast(true, "warning", error.message);
      }
    },

    formattedDate(dateString) {
      const date = new Date(dateString);
      return (
        date.toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        }) +
        " " +
        date.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        })
      );
    },

    // maskedPassword(password) {
    //   if (password.length > 0) {
    //     return "*".repeat(password.length);
    //   } else {
    //     return "";
    //   }
    // },

    maskedPassword(password) {
      if (password !== null && password.length > 0) {
        const maskedDigits = "*".repeat(password.length - 3);
        return password[0] + maskedDigits + password.slice(-2);
      } else {
        return "";
      }
    },
    
    //Export

    async downloadExcel(acquirerId) {
      this.loading = true;
      try {        
        const response = await fetch(window.baseurl + "devices/export/acq/" + acquirerId, {
          method: 'GET',
          headers: {
            'Accept': 'application/octet-stream',
            Authorization: "Bearer " + this.accessToken ,
          },
        }); 
        console.error('response.', response);   
        if (response.status == 200) {
          const blob = await response.blob();  // Convert the response to a blob (binary data)          
          const url = window.URL.createObjectURL(blob);  // Create a URL for the blob
          const link = document.createElement('a');  // Create a temporary download link
          link.href = url;
          // Base file name
          const baseFileName = "Device";
          // Get current date and time
          const now = new Date();
          const formattedDate = now.toISOString().slice(0, 19).replace(/:/g, "-");
          // Combine base file name with date and time
          const fileName = `${baseFileName}_${formattedDate}.xlsx`;
          link.setAttribute('download', fileName);  // Set the file name
          document.body.appendChild(link);
          link.click();  // Simulate a click to trigger the download
          document.body.removeChild(link);  // Clean up
        } else {
          console.error('Failed to download the file.');
        }
        this.loading = false;
      } catch (error) {
        console.error('Error downloading the file:', error);
        this.loading = false;
      }
    },

    async downloadExcel2(orgId) {
      this.loading = true;
      try {        
        const response = await fetch(window.baseurl + "devices/export/org/" + orgId, {
          method: 'GET',
          headers: {
            'Accept': 'application/octet-stream',
            Authorization: "Bearer " + this.accessToken ,
          },
        }); 
        console.error('response.', response);   
        if (response.status == 200) {          
          const blob = await response.blob();  // Convert the response to a blob (binary data)          
          const url = window.URL.createObjectURL(blob);  // Create a URL for the blob
          const link = document.createElement('a');  // Create a temporary download link
          link.href = url;
          // Base file name
          const baseFileName = "Deevice";
          // Get current date and time
          const now = new Date();
          const formattedDate = now.toISOString().slice(0, 19).replace(/:/g, "-");
          // Combine base file name with date and time
          const fileName = `${baseFileName}_${formattedDate}.xlsx`;
          link.setAttribute('download', fileName);  // Set the file name
          document.body.appendChild(link);
          link.click();  // Simulate a click to trigger the download
          document.body.removeChild(link);  // Clean up
        } else {
          console.error('Failed to download the file.');
        }
        this.loading = false;
      } catch (error) {
        console.error('Error downloading the file:', error);
        this.loading = false;
      }
    },

    async downloadExcelAdmin() {
      this.loading = true;
      try {
        
        const response = await fetch(window.baseurl + "devices/export/all", {
          method: 'GET',
          headers: {
            'Accept': 'application/octet-stream',
            Authorization: "Bearer " + this.accessToken ,
          },
        }); 
        console.error('response.', response);   
        if (response.status == 200) {
          const blob = await response.blob();  // Convert the response to a blob (binary data)          
          const url = window.URL.createObjectURL(blob);  // Create a URL for the blob
          const link = document.createElement('a');  // Create a temporary download link
          link.href = url;
          // Base file name
          const baseFileName = "Device";
          // Get current date and time
          const now = new Date();
          const formattedDate = now.toISOString().slice(0, 19).replace(/:/g, "-");
          // Combine base file name with date and time
          const fileName = `${baseFileName}_${formattedDate}.xlsx`;
          link.setAttribute('download', fileName);  // Set the file name
          document.body.appendChild(link);
          link.click();  // Simulate a click to trigger the download
          document.body.removeChild(link);  // Clean up
        } else {
          console.error('Failed to download the file.');
        }
        this.loading = false;
      } catch (error) {
        console.error('Error downloading the file:', error);
        this.loading = false;
      }
    },

    async exportDeviceData(id) {      
      console.log("merchant_object44", id);      
      if(id == "all"){        
        this.downloadExcel2(this.orgId);
      }else{
        this.downloadExcel(id);
      }
      this.dialog_select_acquirer = false;     
    },

    async exportDeviceDataForAdmin(id) {      
      console.log("merchant_object44", id);      
      if(id == "all"){        
        this.downloadExcelAdmin();
      }else{
        this.downloadExcel2(id);
      }
      this.dialog_select_organization = false;
    },

    /*RULES VALIDATION */

    required(v) {
      return !!v || "Field is required";
    },
    validateSerial(value) {
      const regex = /^[0-9]+$/;
      return (
        regex.test(value) ||
        "Device Serial Number can only be numbers and 10 digits."
      );
    },
    validatestmTime(value) {
      const regex = /^[0-9]{1,2}([:][0-9]{1,2})?$/;
      return regex.test(value) || "Check format.";
    },
    validateReceipt(value) {
      if (value >= 1 && value <= 2) {
        return true;
      } else {
        return "Minimum value is 1 and maximum value is 2.";
      }
    },
    validatePassword(value) {
      if (value.length === 6) {
        return true;
      } else {
        return "Password should be 6 digits";
      }
    },
    validateTID(value) {
      const regex = /^[A-Za-z0-9]{8}$/;
      return (
        regex.test(value) ||
        "TID must be exactly 8 characters long and can only contain letters and numbers"
      );
    },
    validateMID(value) {
      const regex = /^[A-Za-z0-9]{15}$/;
      return (
        regex.test(value) ||
        "MID must be exactly 15 characters long and can only contain letters and numbers"
      );
    },
    validateCVM(value) {
      if (value >= 0 && value <= 1000000000) {
        return true;
      } else {
        return "Minimum value is 0 and Maximum value is 1000000000.";
      }
    },
  },
  //get list of acquirers
  async mounted() {
    this.checkTokenExpiry();

    //get device list
    this.fetchData();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

@media screen and (max-width: 600px) {
  .v-data-table thread {
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }

  .v-data-table td {
    border-bottom: thin solid rgba(red, green, blue, alpha);
    display: block;
    text-align: right;
    line-height: 48px;
  }

  .v-data-table td::before {
    content: attr(data-label);
    float: left;
    font-weight: bold;
  }

  .v-data-table td:last-child {
    border-bottom: 0;
  }

  .v-data-table tr:not(:first-child) > td:first-child {
    border-top: medium solid rgba(red, green, blue, alpha);
  }
}
</style>
